<template>
    <div id="contend">
      
         <topbar></topbar>
            <div id="dash">
                <dashboard></dashboard>
            </div>
            <div id="menu">
                <menusis></menusis>
            </div>
            <div id="relatorios">
              <relatorios></relatorios>
            </div>
            <div id="perfil">
              <perfil></perfil>
            </div>
         <footernav></footernav>
     
    
     
    </div>
  </template>
  
  <script>
  /* eslint-disable */
  
import topbar     from './components/topbar.vue'
import footernav  from './components/footerbar.vue'
import dashboard  from './dashboard.vue'
import menusis    from './menusis.vue'
import relatorios from './relatorios.vue'
import perfil from './perfil.vue'
  export default {
    name: 'sss',
    components: {
      footernav,
      topbar,
      dashboard,
      menusis,
      relatorios,
      perfil,

    },
    methods:{
     
    },
    mounted(){
      $('#dash').show();
      $('#menu').hide();
      $('#relatorios').hide();
      $('#perfil').hide();
    }
  }
  </script>
  
  <style>
  
  </style>
  